export const CHANGE_REFRESH = 'CHANGE_REFRESH'
export const CHANGE_HEADER_REFRESH = 'CHANGE_HEADER_REFRESH'
export const CHANGE_HEADER_USERINFO = 'CHANGE_HEADER_USERINFO'
export const DUTYRANGE = 'DUTYRANGE'
export const DUTYRANGECHANGE = 'DUTYRANGECHANGE'
export const SIGNDATACHANGE = 'SIGNDATACHANGE'
export const TagDATACHANGE = 'TagDATACHANGE'
export const DUTYRANGECHANGEFORPLOBLEM = 'DUTYRANGECHANGEFORPLOBLEM'
export const DUTYRANGECHANGEFORPLOBLEMRESET = 'DUTYRANGECHANGEFORPLOBLEMRESET'
export const DUTYWORKING = 'DUTYWORKING'
export const DUTYARRANGEFORPROBLEM = 'DUTYARRANGEFORPROBLEM'
export const DUTYNORMALFORPROBLEM = 'DUTYNORMALFORPROBLEM'
export const DUTYUNNORMALFORPROBLEM = 'DUTYUNNORMALFORPROBLEM'
export const SIGNDATAFORPROBLEMFORCHANGE = 'SIGNDATAFORPROBLEMFORCHANGE'
export const SIGNINSYMBOLFORPROBLEM = 'SIGNINSYMBOLFORPROBLEM'
export const unKnowStatus = 'unKnowStatus'
export const CHANGE_SCROLLER_HEIGHT = 'CHANGE_SCROLLER_HEIGHT' // 页面滚动距离（不带单位）
export const SET_ROUTER = 'SET_ROUTER' // 保存页面离开之前的router信息
export const SET_HIGH_LIGHT_INFO = 'SET_HIGH_LIGHT_INFO' // 保存页面离开之前的router信息
export const CHANGE_RELATEDSTATUS = 'CHANGE_RELATEDSTATUS' // 保存页面离开之前的router信息
export const CHANGE_DETAIL = 'CHANGE_DETAIL' // 保存页面离开之前的router信息
export const INTERFACE_MODEL_STATUS = 'INTERFACE_MODEL_STATUS' // 接口说明弹框显示隐藏状态
export const INTERFACE_MODEL_DATA = 'INTERFACE_MODEL_DATA' // 接口说明弹框回调数据隐藏状态
export const CHANGE_VMRETURNTOCHECK = 'CHANGE_VMRETURNTOCHECK'
export const CHANGE_NETWORKRETURNTOCHECK = 'CHANGE_NETWORKRETURNTOCHECK'
export const CHANGE_SLBRETURNTOCHECK = 'CHANGE_SLBRETURNTOCHECK'
export const CHANGE_ADDRESSRETURNTOCHECK = 'CHANGE_ADDRESSRETURNTOCHECK'
// export const CHANGE_INTENSIVESLBRETURNTOCHECK = 'CHANGE_INTENSIVESLBRETURNTOCHECK'
// export const CHANGE_INTENSIVEADDRESSRETURNTOCHECK = 'CHANGE_INTENSIVEADDRESSRETURNTOCHECK'
export const CHANGE_INTENSIVEWEBSITEACCOUNTRETURNTOCHECK = 'CHANGE_INTENSIVEWEBSITEACCOUNTRETURNTOCHECK'
export const CHANGE_PMRETURNTOCHECK = 'CHANGE_PMRETURNTOCHECK'
export const CHANGE_PMDELRETURNTOCHECK = 'CHANGE_PMDELRETURNTOCHECK'
export const CHANGE_ORACLERETURNTOCHECK = 'CHANGE_ORACLERETURNTOCHECK'
export const SUBTABLE_SELECTED_ITEM = 'SUBTABLE_SELECTED_ITEM' // 接口说明弹框回调数据隐藏状态
export const CHANGE_DATA_RETURN = 'CHANGE_DATA_RETURN' // 接口说明弹框回调数据隐藏状态
export const RESET_DATA_RETURN = 'RESET_DATA_RETURN' // 接口说明弹框回调数据隐藏状态
export const CHANGE_RESOURCE_SHARE_ZONE_SRATUS = 'CHANGE_RESOURCE_SHARE_ZONE_SRATUS'
export const CHANGE_PUBLIC_SERVICE_ZONE_STATUS = 'CHANGE_PUBLIC_SERVICE_ZONE_STATUS'
export const CLEAR_RESOURCE_SHARE_ZONE_SRATUS = 'CLEAR_RESOURCE_SHARE_ZONE_SRATUS'
export const CLEAR_PUBLIC_SERVICE_ZONE_STATUS = 'CLEAR_PUBLIC_SERVICE_ZONE_STATUS'
export const CHANGE_OPERATION_RES_INFO = 'CHANGE_OPERATION_RES_INFO'
export const CHANGE_ALL_SELECT_ARR = 'CHANGE_ALL_SELECT_ARR'
export const CHANGE_DELIVER_SUB_DATA = 'CHANGE_DELIVER_SUB_DATA'
export const CHANGE_DELIVER_DATA = 'CHANGE_DELIVER_DATA'
export const RESTART_INIT = 'RESTART_INIT'
export const CHANGE_EVENT_TAB_NAME = 'CHANGE_EVENT_TAB_NAME'
export const CHANGE_EVENT_PAGE = 'CHANGE_EVENT_PAGE'
export const CHANGE_BACKFILL_LIST = 'CHANGE_BACKFILL_LIST'
export const CHANGE_FULL_SCREEN = 'CHANGE_FULL_SCREEN'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js